
export class MasterdataModel{
  serials='';
  lookupNames='';
  type='';

}
export class ImageTypesModel{
imageid = '' ;
imagename = '' ;
notes = '' ;
userid = '' ;
modifieddate = '2022-02-01' ;

}
export class GovernmentsModel
{
  goveid = '' ;
  govename = '' ;
}
export class RadTypeModel
{
  radtypecode = '' ;
  radtypename = '' ;
  radtypenotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2024-01-01' ;

}
export class HorTypeModel
{
  hortypecode = 0 ;
  hortypename = '' ;
  hortypenotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2024-01-01' ;

}
